<style scoped>
</style>

<template>
	<v-dialog 
		v-model="visible"
		max-width="360"
		persistent
		no-gutters
	>
		<v-alert
			border="top"
			class="mb-0 pr-9"
			color="#EE0202"
			colored-border
			type="error"
			icon="mdi-alert-circle"
			transition="scale-transition"
		>
			<div class="pb-4 font-weight-bold text-body-1" >
				Delete {{ worklist.name }}?
			</div>
			<div class="pb-4">
				Are you sure you want to delete the worklist "{{ worklist.name }}"? 
			</div>
			<div v-if="worklist.acl" class="pb-4">
				This worklist is shared with <span class="black--text font-weight-medium text-decoration-underline"> {{ worklist.acl.join(', ') }} </span>. 
				They will also lose access to the worklist.
			</div>
			<div>
				<v-row 
					no-gutters 
					justify="space-between" 
					v-if="!saving"
				>
					<v-btn 
						outlined 
						@click="close()" 
						color="grey" 
						class="px-4"
					>
						CANCEL
					</v-btn>
					<v-btn 
						@click="deletewl()" 
						color="#EE0202"
						class="white--text"
						:class="$vuetify.breakpoint.smAndDown ? 'px-4':'px-2'"
					>
						<span v-if="$vuetify.breakpoint.smAndDown">DELETE</span>
						<span v-if="!$vuetify.breakpoint.smAndDown">DELETE WORKLIST</span>
					</v-btn>
				</v-row>
				<v-row 
					no-gutters 
					justify="center" 
					v-if="saving"
				>
					<v-progress-circular
						indeterminate
						color="light-blue"
					/>
				</v-row>
			</div>
		</v-alert>
	</v-dialog>
</template>

<script>
import Worklist from "@/models/worklist.js";

export default {
	data() {
		return {
			errormsg: "",
			visible: false,
			saving: false,
			worklist: new Worklist(),
		}
	},
	methods: {
		open(worklist) {
			// copy, should we reload? probably overkill, we only need the id and name
			this.worklist.id = worklist.id;
			this.worklist.class = worklist.class;
			this.worklist.name = worklist.name;
			this.worklist.settings = worklist.settings;
			this.worklist.is_dynamic = worklist.is_dynamic;
			this.worklist.details = worklist.details;
			this.worklist.is_pinned = worklist.is_pinned;
			this.worklist.acl = worklist.acl ? worklist.acl.map(item => { return item.name}) : worklist.acl;

			this.errormsg = "";
			this.visible = true;
		},
		deletewl() {
			// Should validate our entry

			// and save
			this.saving = true;
			this.errormsg = "";

			this.worklist.delete()
				.then(() => {
					// close dialog
					this.visible = false

					if (this.worklist.is_pinned) {
						this.$store.dispatch('update_pinned_job_worklists');
					}

					// let the world know
					this.$emit('deleted');
				})
				.catch(e => {
					console.log(e);
					this.errormsg = e.message;
				})
				.finally(() => {
					this.saving = false;
				});
		}, 
		close() {
			this.visible = false;
		}
	}
}
</script>